import React from 'react';

import { NumberInput, Stack, Text } from '@mantine/core';

import { blockNonDecimal, DistanceResult, DistanceUnit } from './types';

interface DistanceInputProps {
  value: DistanceResult;
  onChange: (value: DistanceResult) => void;
  unit: DistanceUnit;
  enlarged?: boolean;
}

const DistanceInput = ({ value, onChange, unit, enlarged = false }: DistanceInputProps): JSX.Element => {
  const isMeters = unit === 'm';
  return (
    <Stack spacing={4}>
      <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
        Distance
      </Text>
      <NumberInput
        value={value.value}
        onChange={v => onChange({ ...value, value: v })}
        min={0}
        precision={isMeters ? 0 : 2}
        step={isMeters ? 1 : 0.1}
        size={enlarged ? 'xl' : 'md'}
        inputMode='decimal'
        onKeyDown={blockNonDecimal}
        rightSection={
          <Text size={enlarged ? 'md' : 'xs'} color='dimmed' pr={8}>
            {unit}
          </Text>
        }
        rightSectionWidth={40}
      />
    </Stack>
  );
};

export default DistanceInput;
